import React from 'react'
import { HTMLMessageDescriptor } from '@web/walter-lib/react-intl'
import { FormattedHTMLMessage, FormattedCurrency, NotificationInfo } from '@web/walter-ui-kit'

interface Props {
    title: HTMLMessageDescriptor
    amount: string
    sign?: 1 | 0
    currencyCode: string
}

/**
 * Amount Content
 */
function AmountContent({ title, amount, sign = 0, currencyCode }: Props) {
    return (
        <NotificationInfo
            label={<FormattedHTMLMessage {...title} />}
            value={
                <FormattedCurrency
                    dataPointer="notification_value"
                    value={amount}
                    currency={currencyCode}
                    full
                    isSignAlwaysDisplay={sign !== 0}
                />
            }
        />
    )
}

export default AmountContent
